import * as React from "react";
import classnames from "classnames";
import { Divider } from "@grandvisionhq/elements";
import { isNil } from "@grandvisionhq/utils";
import { ShippingThreshold } from "../../../../components/modules/Totals/components/ShippingThreshold.js";
import { PriceRow } from "../../../../components/modules/Totals/components/PriceRow.js";
import { PaymentMethodPrice } from "../../../../components/modules/Totals/components/PaymentMethodPrice.js";
import { Shipping } from "../../../../components/modules/Totals/components/Shipping.js";
import { MainTotal } from "../../../../components/modules/Totals/components/MainTotal.js";
import { useCartSlots } from "../../../../../../slots/slots/context.js";
const Regular = ({
  className,
  currency,
  labels,
  prices,
  settings,
  freeShippingThreshold,
  isMiniCart,
  discountedPrice,
  numberOfItems
}) => {
  const { Slots } = useCartSlots();
  const showShippingThreshold = (!settings.isReadOnly || isMiniCart) && !isNil(freeShippingThreshold) && !isNaN(freeShippingThreshold) && freeShippingThreshold > 0 ? true : false;
  const showShippingThresholdReached = prices.shippingPrice === 0;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, showShippingThreshold && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    ShippingThreshold,
    {
      price: discountedPrice || 0,
      labels,
      freeShippingThreshold: showShippingThresholdReached ? 0 : freeShippingThreshold || 0
    }
  ), /* @__PURE__ */ React.createElement(Divider, { className: "cart-totals__divider divider--light" })), /* @__PURE__ */ React.createElement("div", { role: "list", className: classnames("cart-totals", className), "data-t": "cart-totals" }, /* @__PURE__ */ React.createElement("div", { className: "cart-totals__group" }, /* @__PURE__ */ React.createElement(
    PriceRow,
    {
      label: `${labels.totalItems} (${numberOfItems})`,
      currency,
      price: prices.preDiscountPrice
    }
  ), prices.discountPrice ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    PriceRow,
    {
      label: labels.productDiscounts,
      currency,
      price: -prices.discountPrice,
      isDiscount: true
    }
  )) : null), prices.discountPrice ? /* @__PURE__ */ React.createElement(Divider, { className: "cart-totals__divider divider--light " }) : null, /* @__PURE__ */ React.createElement("div", { className: "cart-totals__group" }, prices.discountPrice ? settings.shouldShowSubTotal && /* @__PURE__ */ React.createElement(
    PriceRow,
    {
      label: labels.subTotal,
      currency,
      price: prices.subTotalPrice,
      isEmphasized: true
    }
  ) : null, prices.paymentMethodPrice && /* @__PURE__ */ React.createElement(
    PaymentMethodPrice,
    {
      label: labels.paymentMethodPrice,
      price: prices.paymentMethodPrice,
      currency
    }
  ), /* @__PURE__ */ React.createElement(Shipping, { labels, price: prices.shippingPrice, currency })), /* @__PURE__ */ React.createElement(Divider, { className: "cart-totals__divider divider--light" }), /* @__PURE__ */ React.createElement(MainTotal, { label: labels.total, price: prices.totalPrice, currency }), Slots.AfterTotals ? /* @__PURE__ */ React.createElement(Slots.AfterTotals, null) : null));
};
export {
  Regular
};
//# sourceMappingURL=Regular.js.map
